import { DownloadFile } from "../../../Utils/helpers";
import ApiClient from "../api-client";
import { EnvType } from "../services";
import { DbInvoiceExpenseInfos } from "../Types/db-invoice-expense-infos";
import { GenericResponseStd } from "../Types/generic-response-std";
import { GetInvoiceResponse } from "../Types/get-invoice-response";
import { GetMySubscriptionResponse } from "../Types/get-my-subscription-response";
import { ListExpensesResponse } from "../Types/list-expenses-response";
import { ListInvoicesResponse } from "../Types/list-invoices-response";
import { ListSubscriptionOffersResponse } from "../Types/list-subscription-offers-response";
import { UpdateMySubscriptionRequest } from "../Types/update-my-subscription-request";
import BillingApiClient, { IBillingApiClient } from "./billing-api-client";

export default class BillingService {
  billingApiClient: IBillingApiClient;

  constructor(envType: EnvType) {
    this.billingApiClient = new BillingApiClient(new ApiClient(envType), envType);
  }

  async ListInvoices(): Promise<ListInvoicesResponse> {
    return await this.billingApiClient.ListInvoices();
  }
  async GetInvoice(id: number): Promise<GetInvoiceResponse> {
    return await this.billingApiClient.GetInvoice(id);
  }
  async ValidateInvoice(id: number): Promise<GenericResponseStd> {
    return await this.billingApiClient.ValidateInvoice(id);
  }
  async ListCurrentExpenses(): Promise<ListExpensesResponse> {
    return await this.billingApiClient.ListCurrentExpenses();
  }
  async AddExpenseOnInvoice(request: DbInvoiceExpenseInfos): Promise<GenericResponseStd> {
    return await this.billingApiClient.AddExpenseOnInvoice(request);
  }
  async GetMySubscription(): Promise<GetMySubscriptionResponse> {
    return await this.billingApiClient.GetMySubscription();
  }
  async UpdateMySubscription(request: UpdateMySubscriptionRequest): Promise<GenericResponseStd> {
    return await this.billingApiClient.UpdateMySubscription(request);
  }
  async ListSubscriptionOffers(): Promise<ListSubscriptionOffersResponse> {
    return await this.billingApiClient.ListSubscriptionOffers();
  }

  async DownloadBillingInvoicePdfExport(id: number): Promise<boolean> {
    const [fileData, headers] = await this.billingApiClient.DownloadBillingInvoicePdfExport(id);

    if (!fileData || fileData.length === 0) return false;
    const headerContentDisp = headers["content-disposition"];
    let fileName = `${id}.pdf`;
    const headerStartsWith = "attachment; filename=";
    if (headerContentDisp && headerContentDisp.includes(headerStartsWith)) {
      const split = headerContentDisp.substring(headerStartsWith.length).split(";");
      fileName = split[0];
    }

    DownloadFile(fileData, "application/pdf", fileName);

    return true;
  }

  //------Utils------
  GetServiceUrl(): string {
    return this.billingApiClient.GetApiUrl();
  }
}
